import { h } from 'preact';
import { Skeleton } from './Skeleton';
import styles from '../product/ProductCard.module.scss';
export function ProductCardSkeleton({ layout = 'gridFour', }) {
    return (h("div", { class: layout === 'gridTwo' || layout === 'gridThree' || layout === 'gridFour'
            ? styles.productCard
            : styles.productCardList },
        h("div", { class: styles.productImage, style: { alignItems: 'flex-start' } },
            h(Skeleton, { width: "100%", height: "410px", borderRadius: "20px" })),
        h("div", { class: styles.cardHeader },
            h("div", { class: styles.headerCenter },
                h("div", { class: styles.reviewsContainer },
                    h("div", { style: { display: 'flex', gap: '2px' } },
                        h(Skeleton, { width: "14px", height: "14px", borderRadius: "2px" }),
                        h(Skeleton, { width: "14px", height: "14px", borderRadius: "2px" }),
                        h(Skeleton, { width: "14px", height: "14px", borderRadius: "2px" }),
                        h(Skeleton, { width: "14px", height: "14px", borderRadius: "2px" }),
                        h(Skeleton, { width: "14px", height: "14px", borderRadius: "2px" })),
                    h(Skeleton, { width: "80px", height: "12px", borderRadius: "4px" })),
                h("div", { style: { marginTop: '8px' } },
                    h(Skeleton, { width: "200px", height: "18px", borderRadius: "4px" })),
                h("div", { style: { marginTop: '8px', display: 'flex', gap: '6px', justifyContent: 'center', alignItems: 'center' } },
                    h(Skeleton, { width: "40px", height: "14px", borderRadius: "4px" }),
                    h(Skeleton, { width: "60px", height: "16px", borderRadius: "4px" }))))));
}
